import React from 'react';

interface AddTitleResponseProps {
  response: {
    titleName?: string;
  };
  label: string;
}

const AddTitleResponse: React.FC<AddTitleResponseProps> = ({ response }) => {
  return <h2 className="text-lg mb-4 text-[#001A55] font-medium">{response.titleName}</h2>;
};

export default AddTitleResponse;
